/* eslint-disable max-len */
export default [
	// general
	{ name: 'logout', path: 'logout?token=:token', alias: [] },
	{ name: 'iasError', path: 'iasError', alias: [] },
	// tasks
	{ name: 'tasks', path: 'tasks', alias: [] },
	{ name: 'taskSearch', path: 'task/search', alias: [] },
	{ name: 'statistics', path: 'task/statistics', alias: [] },
	{ name: 'detail', path: 'task/:taskId/detail', alias: [] },
	{ name: 'printNein', path: 'task/:taskId/printNein', alias: [] },
	{ name: 'requestForSeller', path: 'seller-request', alias: [] },
	{ name: 'mobileScanning', path: 'mobile-scanning', alias: [] },
	{ name: 'backoffice', path: 'backoffice', alias: [] },
	{ name: 'contactClient', path: 'contact-client', alias: [] },
	// campaigns
	{ name: 'campaigns', path: 'campaigns', alias: [] },
	{ name: 'campaignsListSettings', path: 'campaign/settings/list', alias: [] },
	{ name: 'campaignsListManagement', path: 'campaign/management/list', alias: [] },
	{ name: 'campaignsList', path: 'campaign-settings', alias: [] },
	{ name: 'campaignSettings', path: 'campaign/settings/:campaignId', alias: [] },
	{ name: 'campaignManagement', path: 'campaign/management/:campaignId', alias: [] },
	{ name: 'campaignRegionNomination', path: 'campaign/:campaignId/nominations/region', alias: [] },
	{ name: 'campaignSubsellerNomination', path: 'campaign/:campaignId/nominations/subseller', alias: [] },
	//	contacts
	{ name: 'contacts', path: 'contacts', alias: [] },
	{ name: 'contactDetail', path: 'contact-detail/:contactId', alias: [] },
	{ name: 'printContactDetail', path: 'contact-detail/:contactId/print', alias: [] },
	{ name: 'printContactsList', path: 'print', alias: [] },
	// contact history
	{ name: 'contactHistory', path: 'contact-history', alias: [] },
	// leads
	{ name: 'marketPlace', path: 'market-place', alias: [] },
	{ name: 'manualLead', path: 'manual-lead', alias: [] },
	{ name: 'leadDetail', path: 'lead/:leadId/detail', alias: [] },
	// unlocked clients
	{ name: 'unlockedClients', path: 'unlocked-clients', alias: [] },
	// Submitted Production
	{ name: 'producedProduction', path: 'produced-production', alias: [] },
	// others
	{ name: 'dashboard', path: 'dashboard', alias: [] },
	{ name: 'subordinateUsers', path: 'subordinates', alias: [] },
	{ name: 'policyOverview', path: 'policies', alias: [] },
	{ name: 'roboAdvisory', path: 'robo-advisory', alias: [] },
	{ name: 'semaphore', path: 'semaphore', alias: [] },
	{ name: 'settings', path: 'settings', alias: [] },
	{ name: 'kopr', path: 'production-control', alias: [] },
	{ name: 'koprDetail', path: 'productionControl/:documentId/detail', alias: [] },
];
